import { Injectable, inject } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { ClarityService } from '../services/clarity.service';

@Injectable()
export class ClarityInterceptor implements HttpInterceptor {
  private clarityService = inject(ClarityService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          this.clarityService.captureApiResponse(request.url, event.body, request.body);
        }
      })
    );
  }
}
